import { gql } from 'graphql-request'
export const deleteBreweryRouteMutation = gql`mutation deleteBreweryRoute($input: inputDeleteBreweryRoute!) {
	deleteBreweryRoute(input: $input) {
        id,
        title
    }
}`
